import { TaskStatus } from "@examspark/types";

export const taskMaturityList = [
  TaskStatus.ToDo,
  TaskStatus.Blocked,
  TaskStatus.InProgress,
  TaskStatus.ReadyForReview,
  TaskStatus.Done,
];

export const taskMaturityMeta: {
  [key in TaskStatus]: {
    label: string;
    value: TaskStatus;
  };
} = {
  [TaskStatus.ToDo]: {
    label: "To Do",
    value: TaskStatus.ToDo,
  },
  [TaskStatus.Blocked]: {
    label: "Blocked",
    value: TaskStatus.Blocked,
  },
  [TaskStatus.InProgress]: {
    label: "In Progress",
    value: TaskStatus.InProgress,
  },
  [TaskStatus.ReadyForReview]: {
    label: "Ready for Review",
    value: TaskStatus.ReadyForReview,
  },
  [TaskStatus.Cancelled]: {
    label: "Cancelled",
    value: TaskStatus.Cancelled,
  },
  [TaskStatus.Done]: {
    label: "Done",
    value: TaskStatus.Done,
  },
};

export const taskTypeMeta = {
  GENERIC: { value: "GENERIC", label: "General Task" },
  MEDIA_REQUEST: { value: "MEDIA_REQUEST", label: "Media Request" },
  CONTENT_AUDIT: { value: "CONTENT_AUDIT", label: "Content Audit" },
  AUTHORING_ASSIGNMENT: {
    value: "AUTHORING_ASSIGNMENT",
    label: "Authoring Assignment",
  },
  CONTENT_REVIEW: { value: "CONTENT_REVIEW", label: "Content Review" },
  OBJECTIVE_ALIGNMENT: {
    value: "OBJECTIVE_ALIGNMENT",
    label: "Objective Alignment",
  },
};

export const taskLabels = {
  GENERIC: "General Task",
  MEDIA_REQUEST: "Media Request",
  CONTENT_AUDIT: "Content Audit",
  AUTHORING_ASSIGNMENT: "Authoring Assignment",
  CONTENT_REVIEW: "Content Review",
  OBJECTIVE_ALIGNMENT: "Objective Alignment",
};
